import S from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import { ValidationWatcher } from 'lib/validationWatcher';
import { Entrypoints } from 'core/app/entrypoints';

import { ForgotPasswordRequest } from 'data/models/Accounts';

export function ForgotPassword(
    ajax : IAjax,
    entrypoints : Entrypoints
) {
    const client = ajax.Url<ForgotPasswordRequest>(entrypoints.ForgotPassword),
        validation = ValidationWatcher(client),
        forgotPassword = new ForgotPasswordRequest(),
        forgotPasswordRequest = S.data<Request<{}> | null>(null);

    return {
        ForgotPassword: forgotPassword,
        Validation: validation,
        ForgotPasswordRequest: forgotPasswordRequest,
        Submit
    };

    function Submit() {
        forgotPasswordRequest(client.Post(forgotPassword));
    }
}
export type ForgotPassword = ReturnType<typeof ForgotPassword>;


// WEBPACK FOOTER //
// ./apps/portcall/forgotpassword/model.ts